module.exports = __webpack_public_path__ + "img/kraeft-neu.96846bb5.jpg";